"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ServerHand: ['server-hand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,2.5A2.5,2.5,0,0,0,12.5,5h9a2.5,2.5,0,0,0,0-5h-9A2.5,2.5,0,0,0,10,2.5Zm2.75,0A1.25,1.25,0,1,1,14,3.75,1.249,1.249,0,0,1,12.75,2.5Z', 'M10,8.5A2.5,2.5,0,0,0,12.5,11h9a2.5,2.5,0,0,0,0-5h-9A2.5,2.5,0,0,0,10,8.5Zm2.75,0A1.25,1.25,0,1,1,14,9.75,1.249,1.249,0,0,1,12.75,8.5Z', 'M11.2,16.266a2.463,2.463,0,0,1,.114.329.252.252,0,0,0,.134.16A2.45,2.45,0,0,0,12.5,17h9a2.5,2.5,0,0,0,0-5h-9A2.5,2.5,0,0,0,10,14.5a1.662,1.662,0,0,0,.016.189.253.253,0,0,0,.071.145A6.22,6.22,0,0,1,11.2,16.266ZM12.75,14.5A1.25,1.25,0,1,1,14,15.75,1.249,1.249,0,0,1,12.75,14.5Z', 'M3.5,23H14.264A2.239,2.239,0,0,0,16.5,20.763V20.5a1,1,0,0,0-1-1H6.375a.625.625,0,0,1,0-1.25H8.9a1,1,0,0,0,.919-1.394A2.234,2.234,0,0,0,7.764,15.5H3.5A.5.5,0,0,0,3,16v6.5A.5.5,0,0,0,3.5,23Z', 'M1,24a.981.981,0,0,0,.808-.443A.972.972,0,0,0,2,23V15.75a.99.99,0,0,0-.267-.669A.993.993,0,0,0,0,15.75V23A1,1,0,0,0,1,24Z']],
  ServerInformation: ['server-information', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a7.939,7.939,0,0,1,1.543-4.707.5.5,0,0,0-.4-.793h-8A2.6,2.6,0,0,0,.013,14.239,2.5,2.5,0,0,0,2.5,17H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5H9.768a.5.5,0,0,0,.455-.7A8.032,8.032,0,0,1,9.5,17.5ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25A1.25,1.25,0,1,1,9.25,14.5,1.25,1.25,0,0,1,8,15.75Z', 'M1,20a.75.75,0,0,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5A1.25,1.25,0,1,1,4.25,3.75,1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.75,2.5Z', 'M17.427,9.509a.509.509,0,0,0,.49-.378A2.467,2.467,0,0,0,17.9,7.8,2.6,2.6,0,0,0,15.376,6H2.647A2.6,2.6,0,0,0,.013,8.239,2.5,2.5,0,0,0,2.5,11H12.705a.479.479,0,0,0,.271-.086A7.832,7.832,0,0,1,17.427,9.509ZM9.25,8.5A1.25,1.25,0,1,1,8,7.25,1.25,1.25,0,0,1,9.25,8.5ZM5.5,8.5A1.25,1.25,0,1,1,4.25,7.25,1.25,1.25,0,0,1,5.5,8.5Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm8,2.749a.75.75,0,0,1,0,1.5H16a.75.75,0,1,1,0-1.5h.5a.25.25,0,0,0,.25-.25V18a.25.25,0,0,0-.25-.25H16a.75.75,0,1,1,0-1.5h1a1.251,1.251,0,0,1,1.25,1.25V20a.25.25,0,0,0,.25.25Zm-2.25-5a1,1,0,1,1,1-1A1,1,0,0,1,16.75,15.249Z']],
  ServerEdit: ['server-edit', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5v1A2.5,2.5,0,0,0,2.5,6ZM3.635,3A1.115,1.115,0,1,1,4.75,4.115,1.114,1.114,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.614,4.115,1.114,1.114,0,0,1,7.5,3Z', 'M18.468,10.7a4.091,4.091,0,0,1,2.91-1.2h.052a.5.5,0,0,0,.5-.61A2.559,2.559,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13H15.966a.5.5,0,0,0,.353-.147ZM9.729,10A1.115,1.115,0,1,1,8.614,8.885,1.115,1.115,0,0,1,9.729,10ZM5.864,10A1.115,1.115,0,1,1,4.75,8.885,1.114,1.114,0,0,1,5.864,10Z', 'M10.845,18.328l3.474-3.475A.5.5,0,0,0,13.966,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20H9.749a.5.5,0,0,0,.484-.408A2.3,2.3,0,0,1,10.845,18.328ZM3.635,17A1.115,1.115,0,1,1,4.75,18.114,1.114,1.114,0,0,1,3.635,17ZM7.5,17a1.115,1.115,0,1,1,1.114,1.114A1.114,1.114,0,0,1,7.5,17Z', 'M12.74,20.046a.5.5,0,0,0-.835.215l-.885,3.1A.5.5,0,0,0,11.5,24a.466.466,0,0,0,.138-.02l3.1-.886a.5.5,0,0,0,.216-.834Z', 'M21.772,16.935a.5.5,0,0,0,0-.707l-3-3a.5.5,0,0,0-.707,0l-5.011,5.011a.5.5,0,0,0,0,.707l3,3a.5.5,0,0,0,.707,0Z', 'M22.479,15.521a.456.456,0,0,0,.327.125.612.612,0,0,0,.426-.172,2.621,2.621,0,0,0,0-3.707,2.641,2.641,0,0,0-3.755.049.5.5,0,0,0,0,.705Z']],
  ServerEdit1: ['server-edit-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1,20a.75.75,0,0,0,0,1.5H2A.75.75,0,1,0,2,20Z', 'M0,2.5A2.5,2.5,0,0,0,2.5,5h13a2.5,2.5,0,1,0,0-5H2.5A2.5,2.5,0,0,0,0,2.5Zm3,0a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.751,2.5Z', 'M0,8.5A2.5,2.5,0,0,0,2.5,11h13a2.5,2.5,0,1,0,0-5H2.5A2.5,2.5,0,0,0,0,8.5Zm3,0a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,8.5Zm3.75,0A1.25,1.25,0,1,1,8,9.75,1.249,1.249,0,0,1,6.751,8.5Z', 'M0,14.5A2.5,2.5,0,0,0,2.5,17H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5H9.444a.251.251,0,0,0,.25-.247l.054-4.007A.25.25,0,0,1,10,17h1.968a.5.5,0,0,0,.353-.147L16.273,12.9a.5.5,0,0,0-.244-.842A2.413,2.413,0,0,0,15.5,12H2.5A2.5,2.5,0,0,0,0,14.5Zm3,0a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,8,15.75Z', 'M12.739,20.046a.5.5,0,0,0-.479-.131.5.5,0,0,0-.355.346l-.886,3.1A.5.5,0,0,0,11.5,24a.459.459,0,0,0,.137-.02l3.1-.886a.5.5,0,0,0,.216-.834Z', 'M13.054,18.239a.5.5,0,0,0,0,.707l3,3a.5.5,0,0,0,.707,0l5.011-5.011a.5.5,0,0,0,0-.707l-3-3a.5.5,0,0,0-.707,0Z', 'M22.479,15.521a.454.454,0,0,0,.327.125.612.612,0,0,0,.426-.172,2.621,2.621,0,1,0-3.753-3.66.5.5,0,0,0,0,.707Z']],
  Server3: ['server-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,1.5H1.5A1.5,1.5,0,0,0,0,3V6A1.5,1.5,0,0,0,1.5,7.5h21A1.5,1.5,0,0,0,24,6V3A1.5,1.5,0,0,0,22.5,1.5ZM3.25,4.5A1.25,1.25,0,1,1,4.5,5.75,1.251,1.251,0,0,1,3.25,4.5ZM8.5,5.75A1.25,1.25,0,1,1,9.75,4.5,1.252,1.252,0,0,1,8.5,5.75Z', 'M22.5,9H1.5A1.5,1.5,0,0,0,0,10.5v3A1.5,1.5,0,0,0,1.5,15h21A1.5,1.5,0,0,0,24,13.5v-3A1.5,1.5,0,0,0,22.5,9ZM3.25,12A1.25,1.25,0,1,1,4.5,13.25,1.251,1.251,0,0,1,3.25,12ZM8.5,13.25A1.25,1.25,0,1,1,9.75,12,1.252,1.252,0,0,1,8.5,13.25Z', 'M22.5,16.5H1.5A1.5,1.5,0,0,0,0,18v3a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,21V18A1.5,1.5,0,0,0,22.5,16.5Zm-19.25,3A1.25,1.25,0,1,1,4.5,20.75,1.251,1.251,0,0,1,3.25,19.5ZM8.5,20.75A1.25,1.25,0,1,1,9.75,19.5,1.252,1.252,0,0,1,8.5,20.75Z']],
  Server2: ['server-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V8.5A1.5,1.5,0,0,0,1.5,10h21A1.5,1.5,0,0,0,24,8.5V6A1.5,1.5,0,0,0,22.5,4.5ZM3.25,7.25A1.25,1.25,0,1,1,4.5,8.5,1.251,1.251,0,0,1,3.25,7.25ZM8.5,8.5A1.25,1.25,0,1,1,9.75,7.25,1.252,1.252,0,0,1,8.5,8.5Z', 'M22.724,2.052,18.829.105a1,1,0,0,0-.447-.1H5.618a1,1,0,0,0-.447.105l-3.9,1.947A.5.5,0,0,0,1.5,3h21a.5.5,0,0,0,.224-.948Z', 'M22.5,11.5H1.5A1.5,1.5,0,0,0,0,13v2.5A1.5,1.5,0,0,0,1.5,17h21A1.5,1.5,0,0,0,24,15.5V13A1.5,1.5,0,0,0,22.5,11.5ZM3.25,14.25A1.25,1.25,0,1,1,4.5,15.5,1.251,1.251,0,0,1,3.25,14.25ZM8.5,15.5a1.25,1.25,0,1,1,1.25-1.25A1.252,1.252,0,0,1,8.5,15.5Z', 'M22.5,18.5H1.5A1.5,1.5,0,0,0,0,20v2.5A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V20A1.5,1.5,0,0,0,22.5,18.5ZM3.25,21.25A1.25,1.25,0,1,1,4.5,22.5,1.251,1.251,0,0,1,3.25,21.25ZM8.5,22.5a1.25,1.25,0,1,1,1.25-1.25A1.252,1.252,0,0,1,8.5,22.5Z']],
  ServerChoose: ['server-choose', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.938,8.941a.246.246,0,0,0,.089-.191.25.25,0,0,0-.089-.192A3.992,3.992,0,0,1,3.861,7.146.251.251,0,0,0,3.633,7H2a2,2,0,0,0,0,4H3.453a.25.25,0,0,0,.239-.177A4.009,4.009,0,0,1,4.938,8.941Z', 'M4.941,15.441a.249.249,0,0,0,0-.382,3.986,3.986,0,0,1-1.432-2.824A.25.25,0,0,0,3.258,12H2a2,2,0,0,0,0,4H4.285a.25.25,0,0,0,.191-.089A4.3,4.3,0,0,1,4.941,15.441Z', 'M3.5,18.5a3.941,3.941,0,0,1,.181-1.176.248.248,0,0,0-.037-.222.251.251,0,0,0-.2-.1H2a2,2,0,0,0,0,4H3.915a.251.251,0,0,0,.211-.385A3.91,3.91,0,0,1,3.5,18.5Z', 'M18.562,8.558a.25.25,0,0,0-.089.192.246.246,0,0,0,.089.191,4.009,4.009,0,0,1,1.246,1.882.25.25,0,0,0,.239.177H22a2,2,0,0,0,0-4H19.867a.251.251,0,0,0-.228.146A3.992,3.992,0,0,1,18.562,8.558Z', 'M18.561,15.059a.251.251,0,0,0,0,.382,4.3,4.3,0,0,1,.465.47.25.25,0,0,0,.191.089H22a2,2,0,0,0,0-4H20.242a.25.25,0,0,0-.249.235A3.986,3.986,0,0,1,18.561,15.059Z', 'M20,18.5a3.91,3.91,0,0,1-.626,2.115.251.251,0,0,0,.211.385H22a2,2,0,0,0,0-4H20.058a.251.251,0,0,0-.2.1.248.248,0,0,0-.037.222A3.941,3.941,0,0,1,20,18.5Z', 'M7.5,8H16a2.5,2.5,0,0,0,0-5H7.5a2.5,2.5,0,0,0,0,5ZM11,4.5a1,1,0,1,1-1,1A1,1,0,0,1,11,4.5Zm-3.25,0a1,1,0,1,1-1,1A1,1,0,0,1,7.75,4.5Z', 'M7.5,14.5H16a2.5,2.5,0,0,0,0-5H7.5a2.5,2.5,0,0,0,0,5ZM11,11a1,1,0,1,1-1,1A1,1,0,0,1,11,11ZM7.75,11a1,1,0,1,1-1,1A1,1,0,0,1,7.75,11Z', 'M16,21a2.5,2.5,0,0,0,0-5H7.5a2.5,2.5,0,0,0,0,5Zm-5-3.5a1,1,0,1,1-1,1A1,1,0,0,1,11,17.5Zm-3.25,0a1,1,0,1,1-1,1A1,1,0,0,1,7.75,17.5Z']],
  Server1: ['server-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,2.25H1.5A1.5,1.5,0,0,0,0,3.75v2.5a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,6.25V3.75A1.5,1.5,0,0,0,22.5,2.25ZM3.25,5A1.25,1.25,0,1,1,4.5,6.25,1.251,1.251,0,0,1,3.25,5ZM8.5,6.25A1.25,1.25,0,1,1,9.75,5,1.252,1.252,0,0,1,8.5,6.25Zm-7.458-2.7-.005.014Z', 'M22.5,9.25H1.5A1.5,1.5,0,0,0,0,10.75v2.5a1.5,1.5,0,0,0,1.5,1.5h9.25A.25.25,0,0,1,11,15v4.5a.25.25,0,0,1-.25.25H5.5a1,1,0,0,0,0,2h13a1,1,0,0,0,0-2H13.25A.25.25,0,0,1,13,19.5V15a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,1.5-1.5v-2.5A1.5,1.5,0,0,0,22.5,9.25ZM3.25,12A1.25,1.25,0,1,1,4.5,13.25,1.251,1.251,0,0,1,3.25,12ZM8.5,13.25A1.25,1.25,0,1,1,9.75,12,1.252,1.252,0,0,1,8.5,13.25Z', 'M23,21.75a1,1,0,0,0,0-2H22a1,1,0,0,0,0,2Z', 'M1,21.75H2a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z']],
  Server: ['server', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,6a1.5,1.5,0,0,0-1.5-1.5H1.5A1.5,1.5,0,0,0,0,6V8.5A1.5,1.5,0,0,0,1.5,10h21A1.5,1.5,0,0,0,24,8.5ZM3.25,7.248A1.25,1.25,0,1,1,4.5,8.5,1.251,1.251,0,0,1,3.25,7.248ZM8.5,8.5a1.25,1.25,0,1,1,1.25-1.25A1.252,1.252,0,0,1,8.5,8.5Z', 'M22.735,2.054,18.841.107a1,1,0,0,0-.447-.1H5.63a1.007,1.007,0,0,0-.448.105L1.288,2.054A.5.5,0,0,0,1.512,3h21a.5.5,0,0,0,.223-.948Z', 'M24,13a1.5,1.5,0,0,0-1.5-1.5H1.5A1.5,1.5,0,0,0,0,13v2.5A1.5,1.5,0,0,0,1.5,17h9.25a.25.25,0,0,1,.25.25v4.5a.25.25,0,0,1-.25.25H5.5a1,1,0,0,0,0,2h13a1,1,0,0,0,0-2H13.25a.25.25,0,0,1-.25-.25v-4.5a.25.25,0,0,1,.25-.25H22.5A1.5,1.5,0,0,0,24,15.5ZM3.25,14.248A1.25,1.25,0,1,1,4.5,15.5,1.251,1.251,0,0,1,3.25,14.248ZM8.5,15.5a1.25,1.25,0,1,1,1.25-1.25A1.252,1.252,0,0,1,8.5,15.5Z', 'M23,24a1,1,0,0,0,0-2H22a1,1,0,0,0,0,2Z', 'M1,24H2a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z']],
  Server4: ['server-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.5,5.979h17a2.5,2.5,0,0,0,2.5-2.5v-1a2.5,2.5,0,0,0-2.5-2.5H3.5A2.5,2.5,0,0,0,1,2.479v1A2.5,2.5,0,0,0,3.5,5.979Zm1.135-3A1.115,1.115,0,1,1,5.75,4.093,1.115,1.115,0,0,1,4.635,2.978Zm3.865,0A1.115,1.115,0,1,1,9.615,4.093,1.114,1.114,0,0,1,8.5,2.978Z', 'M1,10.479a2.5,2.5,0,0,0,2.5,2.5h17a2.5,2.5,0,0,0,2.5-2.5v-1a2.5,2.5,0,0,0-2.5-2.5H3.5A2.5,2.5,0,0,0,1,9.479Zm3.635-.5A1.115,1.115,0,1,1,5.75,11.093,1.115,1.115,0,0,1,4.635,9.978Zm3.865,0a1.115,1.115,0,1,1,1.115,1.115A1.114,1.114,0,0,1,8.5,9.978Z', 'M20.5,19.979a2.5,2.5,0,0,0,2.5-2.5v-1a2.5,2.5,0,0,0-2.5-2.5H3.5a2.5,2.5,0,0,0-2.5,2.5v1a2.5,2.5,0,0,0,2.5,2.5H11a.25.25,0,0,1,.25.25v2.042a.25.25,0,0,1-.25.25H5.5a.75.75,0,0,0,0,1.5h13a.75.75,0,0,0,0-1.5H13a.25.25,0,0,1-.25-.25V20.229a.25.25,0,0,1,.25-.25Zm-9.771-3a1.115,1.115,0,1,1-1.114-1.114A1.115,1.115,0,0,1,10.729,16.978Zm-3.864,0A1.115,1.115,0,1,1,5.75,15.864,1.115,1.115,0,0,1,6.865,16.978Z', 'M22,24.021h1a.75.75,0,0,0,0-1.5H22a.75.75,0,0,0,0,1.5Z', 'M1,22.521a.75.75,0,0,0,0,1.5H2a.75.75,0,0,0,0-1.5Z']],
  ServerCash: ['server-cash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.484a2.5,2.5,0,0,0,2.5,2.5h17a2.5,2.5,0,0,0,2.5-2.5v-1a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,2.484Zm3.635-.5A1.115,1.115,0,1,1,4.75,4.1,1.115,1.115,0,0,1,3.635,2.984Zm3.865,0A1.115,1.115,0,1,1,8.615,4.1,1.114,1.114,0,0,1,7.5,2.984Z', 'M17.5,9.515a7.946,7.946,0,0,1,3.777.95A.5.5,0,0,0,22,10.022c0-.14,0-.314,0-.532a2.5,2.5,0,0,0-2.5-2.506H2.5A2.5,2.5,0,0,0,0,9.484v1a2.5,2.5,0,0,0,2.5,2.5h8.164a.49.49,0,0,0,.395-.2A7.991,7.991,0,0,1,17.5,9.515Zm-7.771.469A1.115,1.115,0,1,1,8.615,8.869,1.114,1.114,0,0,1,9.729,9.984Zm-3.864,0A1.115,1.115,0,1,1,4.75,8.869,1.115,1.115,0,0,1,5.865,9.984Z', 'M9.569,13.984H2.5a2.5,2.5,0,0,0-2.5,2.5v1a2.5,2.5,0,0,0,2.5,2.5H9.238a.493.493,0,0,0,.485-.608,7.883,7.883,0,0,1,.315-4.725A.5.5,0,0,0,9.569,13.984Zm-5.934,3A1.115,1.115,0,1,1,4.75,18.1,1.115,1.115,0,0,1,3.635,16.984Z', 'M11,17.515a6.5,6.5,0,1,0,6.5-6.5A6.508,6.508,0,0,0,11,17.515Zm5,3.75a.75.75,0,0,1,0-1.5h2.033a.592.592,0,0,0,.22-1.141L16.19,17.8a2.084,2.084,0,0,1,.36-3.981.249.249,0,0,0,.2-.245v-.308a.75.75,0,0,1,1.5,0v.25a.25.25,0,0,0,.25.25H19a.75.75,0,0,1,0,1.5H16.967a.592.592,0,0,0-.221,1.141l2.064.825a2.085,2.085,0,0,1-.36,3.982.249.249,0,0,0-.2.245v.307a.75.75,0,0,1-1.5,0v-.25a.25.25,0,0,0-.25-.25Z']],
  ServerCheck1: ['server-check-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a7.939,7.939,0,0,1,1.543-4.707.5.5,0,0,0-.4-.793h-8A2.6,2.6,0,0,0,.013,14.239,2.5,2.5,0,0,0,2.5,17H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5H9.768a.5.5,0,0,0,.455-.7A8.032,8.032,0,0,1,9.5,17.5ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25A1.25,1.25,0,1,1,9.25,14.5,1.25,1.25,0,0,1,8,15.75Z', 'M1,20a.75.75,0,0,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5A1.25,1.25,0,1,1,4.25,3.75,1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.75,2.5Z', 'M17.917,9.131A2.467,2.467,0,0,0,17.9,7.8,2.6,2.6,0,0,0,15.376,6H2.647A2.6,2.6,0,0,0,.013,8.239,2.5,2.5,0,0,0,2.5,11H12.705a.479.479,0,0,0,.271-.086,7.832,7.832,0,0,1,4.451-1.4A.509.509,0,0,0,17.917,9.131ZM9.25,8.5A1.25,1.25,0,1,1,8,7.25,1.25,1.25,0,0,1,9.25,8.5ZM5.5,8.5A1.25,1.25,0,1,1,4.25,7.25,1.25,1.25,0,0,1,5.5,8.5Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm5.773,3.175c-.037,0-.074,0-.111,0a1.489,1.489,0,0,1-1.056-.443l-1.5-1.5a.75.75,0,0,1,1.061-1.061l1.3,1.3a.25.25,0,0,0,.376-.027L19.574,15.3a.75.75,0,0,1,1.2.9l-2.905,3.874A1.5,1.5,0,0,1,16.773,20.675Z']],
  ServerCheck: ['server-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5v1A2.5,2.5,0,0,0,2.5,6ZM3.635,3A1.115,1.115,0,1,1,4.75,4.115,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.115,1.114,1.114,0,0,1,7.5,3Z', 'M17.5,9.5a7.957,7.957,0,0,1,3.777.949A.493.493,0,0,0,22,10.01c0-.135,0-.3,0-.508A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13h8.139a.49.49,0,0,0,.4-.206A7.992,7.992,0,0,1,17.5,9.5ZM9.729,10A1.115,1.115,0,1,1,8.615,8.885,1.114,1.114,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M2.5,20H9.242a.505.505,0,0,0,.481-.638,7.868,7.868,0,0,1,.3-4.687A.5.5,0,0,0,9.56,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20Zm1.135-3A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm4.262-.166,1.3,1.3a.253.253,0,0,0,.2.073.249.249,0,0,0,.182-.1l2.731-3.643a.75.75,0,0,1,1.2.9l-2.905,3.874a1.493,1.493,0,0,1-1.1.6c-.037,0-.075,0-.112,0a1.486,1.486,0,0,1-1.055-.443l-1.5-1.5a.75.75,0,0,1,1.061-1.061Z']],
  ServerDisable: ['server-disable', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.5A2.5,2.5,0,0,0,2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5ZM3.635,3A1.115,1.115,0,1,1,4.75,4.114,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.114,1.114,1.114,0,0,1,7.5,3Z', 'M17.5,9.5a7.957,7.957,0,0,1,3.777.949A.493.493,0,0,0,22,10.01c0-.136,0-.3,0-.508A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13h8.139a.491.491,0,0,0,.4-.206A7.992,7.992,0,0,1,17.5,9.5ZM9.729,10A1.115,1.115,0,1,1,8.615,8.885,1.115,1.115,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M2.5,20H9.242a.5.5,0,0,0,.481-.638,7.866,7.866,0,0,1,.3-4.687A.5.5,0,0,0,9.56,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20Zm1.135-3A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5ZM17.5,22a4.438,4.438,0,0,1-2.1-.532.255.255,0,0,1-.129-.184.251.251,0,0,1,.071-.214l5.727-5.726a.249.249,0,0,1,.4.059A4.416,4.416,0,0,1,22,17.5,4.505,4.505,0,0,1,17.5,22Zm2.1-8.468a.249.249,0,0,1,.059.4l-5.728,5.727a.249.249,0,0,1-.213.071.253.253,0,0,1-.184-.129A4.426,4.426,0,0,1,13,17.5,4.5,4.5,0,0,1,17.5,13,4.423,4.423,0,0,1,19.6,13.532Z']],
  ServerDownload: ['server-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.5A2.5,2.5,0,0,0,2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5ZM3.635,3A1.115,1.115,0,1,1,4.75,4.115,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.115,1.114,1.114,0,0,1,7.5,3Z', 'M17.5,9.5a7.957,7.957,0,0,1,3.777.949A.493.493,0,0,0,22,10.01c0-.135,0-.3,0-.508A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13h8.139a.49.49,0,0,0,.4-.206A7.992,7.992,0,0,1,17.5,9.5ZM9.729,10A1.115,1.115,0,1,1,8.615,8.885,1.114,1.114,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M2.5,20H9.242a.505.505,0,0,0,.481-.638,7.868,7.868,0,0,1,.3-4.687A.5.5,0,0,0,9.56,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20Zm1.135-3A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm6.5-4a1,1,0,0,1,1,1v2.75a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.391.812l-2,2.5a.5.5,0,0,1-.782,0l-2-2.5A.5.5,0,0,1,15.5,17.5h.75a.25.25,0,0,0,.25-.25V14.5A1,1,0,0,1,17.5,13.5Z']],
  ServerClock1: ['server-clock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9,17.25a8.2,8.2,0,0,1,1.324-4.478A.5.5,0,0,0,9.9,12H2.5a2.5,2.5,0,0,0,0,5H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5H9.354a.5.5,0,0,0,.451-.716A8.16,8.16,0,0,1,9,17.25ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25A1.25,1.25,0,1,1,9.25,14.5,1.25,1.25,0,0,1,8,15.75Z', 'M1,20a.75.75,0,0,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5A1.25,1.25,0,1,1,4.25,3.75,1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.75,2.5Z', 'M17.483,9A.5.5,0,0,0,18,8.509,2.507,2.507,0,0,0,15.5,6H2.5a2.5,2.5,0,0,0,0,5h9.2a.5.5,0,0,0,.318-.115A8.224,8.224,0,0,1,17.483,9ZM9.25,8.5A1.25,1.25,0,1,1,8,7.25,1.25,1.25,0,0,1,9.25,8.5ZM5.5,8.5A1.25,1.25,0,1,1,4.25,7.25,1.25,1.25,0,0,1,5.5,8.5Z', 'M10.5,17.25a6.75,6.75,0,1,0,6.75-6.75A6.758,6.758,0,0,0,10.5,17.25ZM17.25,22A4.75,4.75,0,1,1,22,17.25,4.756,4.756,0,0,1,17.25,22Z', 'M19.25,16.25H18.5a.25.25,0,0,1-.25-.25V14.75a1,1,0,0,0-2,0v2.5a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2Z']],
  ServerLock1: ['server-lock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,20a.25.25,0,0,1-.25-.25v-2.5A.25.25,0,0,1,10,17h2a.5.5,0,0,0,.5-.5V16a1.994,1.994,0,0,1,1.207-1.83.5.5,0,0,0,.3-.432,4.9,4.9,0,0,1,.182-1.1.5.5,0,0,0-.48-.638H2.5a2.5,2.5,0,0,0,0,5H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5h7a.5.5,0,0,0,.5-.5v-.5A.5.5,0,0,0,12,20ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25A1.25,1.25,0,1,1,9.25,14.5,1.25,1.25,0,0,1,8,15.75Z', 'M1,20a.75.75,0,0,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5A1.25,1.25,0,1,1,4.25,3.75,1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.75,2.5Z', 'M17.622,9.2a.5.5,0,0,0,.358-.412A2.1,2.1,0,0,0,18,8.5,2.5,2.5,0,0,0,15.5,6H2.5a2.5,2.5,0,0,0,0,5H14.782a.5.5,0,0,0,.385-.181A4.989,4.989,0,0,1,17.622,9.2ZM3,8.5A1.25,1.25,0,1,1,4.25,9.75,1.249,1.249,0,0,1,3,8.5ZM8,9.75A1.25,1.25,0,1,1,9.25,8.5,1.25,1.25,0,0,1,8,9.75Z', 'M19,10.75a3.5,3.5,0,0,0-3.5,3.5v1.018a.25.25,0,0,1-.214.247A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17a1.5,1.5,0,0,0-1.286-1.485.25.25,0,0,1-.214-.247V14.25A3.5,3.5,0,0,0,19,10.75Zm1,9.5a1,1,0,1,1-1-1A1,1,0,0,1,20,20.25Zm-1-7.5a1.5,1.5,0,0,1,1.5,1.5v1a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25v-1A1.5,1.5,0,0,1,19,12.75Z']],
  ServerMail: ['server-mail', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.548,13.127a.654.654,0,0,0-.088-.433.5.5,0,0,0-.4-.194H2.5a2.5,2.5,0,0,0,0,5H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20.5H5A.75.75,0,0,0,5,22H9a.5.5,0,0,0,.5-.5S9.531,14.045,9.548,13.127ZM3,15a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,15Zm5,1.25A1.25,1.25,0,1,1,9.25,15,1.25,1.25,0,0,1,8,16.25Z', 'M2,20.5H1A.75.75,0,0,0,1,22H2a.75.75,0,0,0,0-1.5Z', 'M2.5,5.5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,3A1.25,1.25,0,1,1,4.25,4.25,1.249,1.249,0,0,1,3,3ZM6.75,3A1.25,1.25,0,1,1,8,4.25,1.249,1.249,0,0,1,6.75,3Z', 'M0,9a2.5,2.5,0,0,0,2.5,2.5h13a2.5,2.5,0,0,0,0-5H2.5A2.5,2.5,0,0,0,0,9ZM3,9a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,9ZM6.75,9A1.25,1.25,0,1,1,8,10.25,1.249,1.249,0,0,1,6.75,9Z', 'M22.5,23.5A1.5,1.5,0,0,0,24,22V17.26a.252.252,0,0,0-.25-.25.246.246,0,0,0-.131.038l-4.93,3.081a2.254,2.254,0,0,1-2.381,0l-4.927-3.079a.245.245,0,0,0-.131-.037.249.249,0,0,0-.25.25V22a1.5,1.5,0,0,0,1.5,1.5Z', 'M15.5,13.5h-3a1.367,1.367,0,0,0-1.53,1.46.223.223,0,0,0,.108.13L17.1,18.855a.754.754,0,0,0,.794,0l5.976-3.735A.255.255,0,0,0,24,14.891,1.5,1.5,0,0,0,22.5,13.5Z']],
  ServerQuestion1: ['server-question-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a7.939,7.939,0,0,1,1.543-4.707.5.5,0,0,0-.4-.793h-8A2.6,2.6,0,0,0,.013,14.239,2.5,2.5,0,0,0,2.5,17H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5H9.768a.5.5,0,0,0,.455-.7A8.032,8.032,0,0,1,9.5,17.5ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25A1.25,1.25,0,1,1,9.25,14.5,1.25,1.25,0,0,1,8,15.75Z', 'M1,20a.75.75,0,0,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5A1.25,1.25,0,1,1,4.25,3.75,1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.75,2.5Z', 'M17.917,9.131A2.467,2.467,0,0,0,17.9,7.8,2.6,2.6,0,0,0,15.376,6H2.647A2.6,2.6,0,0,0,.013,8.239,2.5,2.5,0,0,0,2.5,11H12.705a.479.479,0,0,0,.271-.086,7.832,7.832,0,0,1,4.451-1.4A.509.509,0,0,0,17.917,9.131ZM9.25,8.5A1.25,1.25,0,1,1,8,7.25,1.25,1.25,0,0,1,9.25,8.5ZM5.5,8.5A1.25,1.25,0,1,1,4.25,7.25,1.25,1.25,0,0,1,5.5,8.5Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm6.5,3a1,1,0,1,1-1,1A1,1,0,0,1,17.5,20.5Zm.913-2.164a.25.25,0,0,0-.163.234v.18a.75.75,0,0,1-1.5,0V18.2a1.258,1.258,0,0,1,.986-1.222,1.125,1.125,0,1,0-1.361-1.1.75.75,0,0,1-1.5,0,2.625,2.625,0,1,1,3.538,2.461Z']],
  ServerRemove1: ['server-remove-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a7.939,7.939,0,0,1,1.543-4.707.5.5,0,0,0-.4-.793h-8A2.6,2.6,0,0,0,.013,14.239,2.5,2.5,0,0,0,2.5,17H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5H9.768a.5.5,0,0,0,.455-.7A8.032,8.032,0,0,1,9.5,17.5ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25A1.25,1.25,0,1,1,9.25,14.5,1.25,1.25,0,0,1,8,15.75Z', 'M1,20a.75.75,0,0,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5A1.25,1.25,0,1,1,4.25,3.75,1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.75,2.5Z', 'M17.427,9.509a.509.509,0,0,0,.49-.378A2.467,2.467,0,0,0,17.9,7.8,2.6,2.6,0,0,0,15.376,6H2.647A2.6,2.6,0,0,0,.013,8.239,2.5,2.5,0,0,0,2.5,11H12.705a.479.479,0,0,0,.271-.086A7.832,7.832,0,0,1,17.427,9.509ZM9.25,8.5A1.25,1.25,0,1,1,8,7.25,1.25,1.25,0,0,1,9.25,8.5ZM5.5,8.5A1.25,1.25,0,1,1,4.25,7.25,1.25,1.25,0,0,1,5.5,8.5Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm9.151,1.591a.75.75,0,1,1-1.06,1.06l-1.414-1.414a.25.25,0,0,0-.354,0l-1.414,1.414a.75.75,0,1,1-1.06-1.06l1.414-1.414a.252.252,0,0,0,0-.354l-1.414-1.414a.75.75,0,0,1,1.06-1.061l1.414,1.414a.25.25,0,0,0,.354,0l1.414-1.414a.75.75,0,1,1,1.06,1.061l-1.414,1.414a.252.252,0,0,0,0,.354Z']],
  ServerSearch1: ['server-search-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.565,20.236A.5.5,0,0,0,10.14,20H10a.25.25,0,0,1-.25-.25V18.359a6.941,6.941,0,0,1,.847-5.591A.5.5,0,0,0,10.175,12H2.5a2.5,2.5,0,0,0,0,5H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5h5.478a.5.5,0,0,0,.4-.8C10.77,20.553,10.665,20.4,10.565,20.236ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25A1.25,1.25,0,1,1,9.25,14.5,1.25,1.25,0,0,1,8,15.75Z', 'M2,20H1a.75.75,0,0,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5A1.25,1.25,0,1,1,4.25,3.75,1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.75,2.5Z', 'M16.529,9.5a6.576,6.576,0,0,1,.823.053.5.5,0,0,0,.54-.347A2.39,2.39,0,0,0,18,8.5,2.5,2.5,0,0,0,15.5,6H2.5a2.5,2.5,0,0,0,0,5h9.535a.5.5,0,0,0,.3-.1A6.984,6.984,0,0,1,16.529,9.5ZM9.25,8.5A1.25,1.25,0,1,1,8,7.25,1.25,1.25,0,0,1,9.25,8.5ZM5.5,8.5A1.25,1.25,0,1,1,4.25,7.25,1.25,1.25,0,0,1,5.5,8.5Z', 'M11,16.529a5.524,5.524,0,0,0,8.5,4.66.25.25,0,0,1,.311.034l2.484,2.484a1,1,0,0,0,1.414-1.414l-2.484-2.484a.251.251,0,0,1-.034-.312A5.527,5.527,0,1,0,11,16.529Zm5.529,3.529a3.529,3.529,0,1,1,3.529-3.529A3.533,3.533,0,0,1,16.529,20.058Z']],
  ServerSubtract: ['server-subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5v1A2.5,2.5,0,0,0,2.5,6ZM3.635,3A1.115,1.115,0,1,1,4.75,4.115,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.115,1.114,1.114,0,0,1,7.5,3Z', 'M17.5,9.5a7.957,7.957,0,0,1,3.777.949A.493.493,0,0,0,22,10.01c0-.136,0-.3,0-.508A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13h8.139a.491.491,0,0,0,.4-.206A7.992,7.992,0,0,1,17.5,9.5ZM9.729,10A1.115,1.115,0,1,1,8.615,8.885,1.114,1.114,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M2.5,20H9.242a.5.5,0,0,0,.481-.638,7.866,7.866,0,0,1,.3-4.687A.5.5,0,0,0,9.56,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20Zm1.135-3A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm4.042-.709h5a.75.75,0,0,1,0,1.5h-5a.75.75,0,1,1,0-1.5Z']],
  ServerShare1: ['server-share-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.7,20.75a.75.75,0,0,0-.75-.75h-1a.75.75,0,0,0,0,1.5h1A.75.75,0,0,0,2.7,20.75Z', 'M2.451,5h13a2.5,2.5,0,0,0,0-5h-13a2.5,2.5,0,0,0,0,5Zm.5-2.5A1.25,1.25,0,1,1,4.2,3.75,1.249,1.249,0,0,1,2.951,2.5Zm3.75,0a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,6.7,2.5Z', 'M-.049,8.5a2.5,2.5,0,0,0,2.5,2.5h13a2.5,2.5,0,0,0,0-5h-13A2.5,2.5,0,0,0-.049,8.5Zm3,0A1.25,1.25,0,1,1,4.2,9.75,1.249,1.249,0,0,1,2.951,8.5Zm3.75,0a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,6.7,8.5Z', 'M2.6,17H7.951a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25h-3a.75.75,0,0,0,0,1.5h5a.5.5,0,0,0,.4-.784A4.256,4.256,0,0,1,13.8,14a4.209,4.209,0,0,1,1.986.5.511.511,0,0,0,.685-.237c.185-.365.43-.855.583-1.2a.481.481,0,0,0-.137-.585A2.476,2.476,0,0,0,15.451,12h-13A2.5,2.5,0,0,0-.036,14.76,2.6,2.6,0,0,0,2.6,17Zm.353-2.5A1.25,1.25,0,1,1,4.2,15.75,1.249,1.249,0,0,1,2.951,14.5Zm5,1.25A1.25,1.25,0,1,1,9.2,14.5,1.25,1.25,0,0,1,7.951,15.75Z', 'M18.612,14.289a.249.249,0,0,1-.116.267l-2.665,1.6a.248.248,0,0,1-.288-.022,2.752,2.752,0,1,0,.311,3.926.247.247,0,0,1,.28-.067l2.272.909a.249.249,0,0,1,.157.246A2.744,2.744,0,1,0,21.3,18.5a2.725,2.725,0,0,0-2.055.941.252.252,0,0,1-.281.067L16.7,18.6a.249.249,0,0,1-.156-.253,2.1,2.1,0,0,0-.057-.638.25.25,0,0,1,.116-.268l2.665-1.6a.249.249,0,0,1,.288.022A2.726,2.726,0,0,0,21.3,16.5a2.75,2.75,0,1,0-2.687-2.211Z']],
  ServerSync1: ['server-sync-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a7.939,7.939,0,0,1,1.543-4.707.5.5,0,0,0-.4-.793h-8A2.6,2.6,0,0,0,.013,14.239,2.5,2.5,0,0,0,2.5,17H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5H9.768a.5.5,0,0,0,.455-.7A8.032,8.032,0,0,1,9.5,17.5ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25A1.25,1.25,0,1,1,9.25,14.5,1.25,1.25,0,0,1,8,15.75Z', 'M1,20a.75.75,0,0,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5A1.25,1.25,0,1,1,4.25,3.75,1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.75,2.5Z', 'M17.917,9.131A2.467,2.467,0,0,0,17.9,7.8,2.6,2.6,0,0,0,15.376,6H2.647A2.6,2.6,0,0,0,.013,8.239,2.5,2.5,0,0,0,2.5,11H12.705a.479.479,0,0,0,.271-.086,7.832,7.832,0,0,1,4.451-1.4A.509.509,0,0,0,17.917,9.131ZM9.25,8.5A1.25,1.25,0,1,1,8,7.25,1.25,1.25,0,0,1,9.25,8.5ZM5.5,8.5A1.25,1.25,0,1,1,4.25,7.25,1.25,1.25,0,0,1,5.5,8.5Z', 'M11.309,23.141a.5.5,0,0,0,.545-.108l.969-.97a.25.25,0,0,1,.359.006,6.086,6.086,0,0,0,10.21-2.2,1,1,0,0,0-1.893-.649,4.09,4.09,0,0,1-6.918,1.42.249.249,0,0,1,.008-.344l1.721-1.722a.5.5,0,0,0-.353-.854H11.5a.5.5,0,0,0-.5.5v4.457a.485.485,0,0,0,.068.224.45.45,0,0,0,.087.112A.47.47,0,0,0,11.309,23.141Z', 'M22.121,12.906a.251.251,0,0,1-.358,0,6.1,6.1,0,0,0-10.2,2.227,1,1,0,0,0,1.893.648,4.092,4.092,0,0,1,6.9-1.445.249.249,0,0,1-.007.346l-1.659,1.66a.5.5,0,0,0,.353.853H23.5a.5.5,0,0,0,.5-.5V12.234a.5.5,0,0,0-.309-.462.485.485,0,0,0-.455.061c-.029.018-.064.022-.09.048Z']],
  ServerUpload1: ['server-upload-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.375,17.375a7.928,7.928,0,0,1,1.377-4.47.5.5,0,0,0-.408-.78H2.772A2.6,2.6,0,0,0,.138,14.364a2.5,2.5,0,0,0,2.487,2.761h5.5a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25h-3a.75.75,0,0,0,0,1.5H9.762a.5.5,0,0,0,.446-.714A7.912,7.912,0,0,1,9.375,17.375Zm-6.25-2.75a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3.125,14.625Zm5,1.25a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,8.125,15.875Z', 'M1.125,20.125a.75.75,0,0,0,0,1.5h1a.75.75,0,0,0,0-1.5Z', 'M.125,2.625a2.5,2.5,0,0,0,2.5,2.5h13a2.5,2.5,0,0,0,0-5h-13A2.5,2.5,0,0,0,.125,2.625Zm3,0a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3.125,2.625Zm3.75,0a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,6.875,2.625Z', 'M17.587,9.378a.5.5,0,0,0,.511-.445,2.49,2.49,0,0,0-2.473-2.808H2.772A2.6,2.6,0,0,0,.138,8.364a2.5,2.5,0,0,0,2.487,2.761H12.23a.494.494,0,0,0,.3-.1A7.956,7.956,0,0,1,17.587,9.378ZM9.375,8.625a1.25,1.25,0,1,1-1.25-1.25A1.25,1.25,0,0,1,9.375,8.625Zm-3.75,0a1.25,1.25,0,1,1-1.25-1.25A1.25,1.25,0,0,1,5.625,8.625Z', 'M10.875,17.375a6.5,6.5,0,1,0,6.5-6.5A6.508,6.508,0,0,0,10.875,17.375Zm8.951-.283a.5.5,0,0,1-.451.283h-.75a.25.25,0,0,0-.25.25v2.75a1,1,0,0,1-2,0v-2.75a.25.25,0,0,0-.25-.25h-.75a.5.5,0,0,1-.391-.813l2-2.5a.52.52,0,0,1,.782,0l2,2.5A.5.5,0,0,1,19.826,17.092Z']],
  ServerSync: ['server-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.5A2.5,2.5,0,0,0,2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5ZM3.635,3A1.115,1.115,0,1,1,4.75,4.114,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.114,1.114,1.114,0,0,1,7.5,3Z', 'M17.5,9.5a8.17,8.17,0,0,1,3.783.926A.493.493,0,0,0,22,9.982V9.5A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13h8.019a.491.491,0,0,0,.393-.2A8.233,8.233,0,0,1,17.5,9.5ZM9.729,10A1.115,1.115,0,1,1,8.615,8.885,1.115,1.115,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M2.5,20H8.925a.5.5,0,0,0,.491-.593,8.24,8.24,0,0,1,.434-4.73A.5.5,0,0,0,9.386,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20Zm1.135-3A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17Z', 'M11.854,23.033l.969-.97a.25.25,0,0,1,.359.006,6.086,6.086,0,0,0,10.21-2.2,1,1,0,0,0-1.893-.649,4.09,4.09,0,0,1-6.918,1.42.249.249,0,0,1,.008-.344l1.721-1.722a.5.5,0,0,0-.353-.854H11.5a.5.5,0,0,0-.5.5v4.457a.485.485,0,0,0,.068.224.45.45,0,0,0,.087.112.47.47,0,0,0,.154.126A.5.5,0,0,0,11.854,23.033Z', 'M22.121,12.906a.251.251,0,0,1-.358,0,6.1,6.1,0,0,0-10.2,2.227,1,1,0,0,0,1.893.648,4.092,4.092,0,0,1,6.9-1.445.249.249,0,0,1-.007.346l-1.659,1.66a.5.5,0,0,0,.353.853H23.5a.5.5,0,0,0,.5-.5V12.234a.5.5,0,0,0-.309-.462.485.485,0,0,0-.455.061c-.029.018-.064.022-.09.048Z']],
  ServerWarning500: ['server-warning-500', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.033.771a1.45,1.45,0,0,0-2.562,0L5.415,10.405a1.431,1.431,0,0,0,.048,1.408A1.456,1.456,0,0,0,6.7,12.5H16.808a1.456,1.456,0,0,0,1.233-.687,1.431,1.431,0,0,0,.048-1.408ZM11.752,3.25A.75.75,0,0,1,12.5,4V7A.75.75,0,1,1,11,7V4A.75.75,0,0,1,11.752,3.25Zm0,5.5a1,1,0,1,1-1,1A1,1,0,0,1,11.752,8.75Z', 'M5.5,21a1,1,0,0,1-1,1h-3a1,1,0,0,0,0,2h3a3,3,0,0,0,0-6H2.75a.25.25,0,0,1-.25-.25v-1.5A.25.25,0,0,1,2.75,16H6.5a1,1,0,0,0,0-2h-5a1,1,0,0,0-1,1v3a2,2,0,0,0,2,2h2A1,1,0,0,1,5.5,21Z', 'M8.5,17.5v3a3.5,3.5,0,0,0,7,0v-3a3.5,3.5,0,0,0-7,0Zm2,0a1.5,1.5,0,0,1,3,0v3a1.5,1.5,0,0,1-3,0Z', 'M16.5,17.5v3a3.5,3.5,0,0,0,7,0v-3a3.5,3.5,0,0,0-7,0Zm2,0a1.5,1.5,0,0,1,3,0v3a1.5,1.5,0,0,1-3,0Z']],
  ServerAdd1: ['server-add-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a7.939,7.939,0,0,1,1.543-4.707.5.5,0,0,0-.4-.793h-8A2.6,2.6,0,0,0,.013,14.239,2.5,2.5,0,0,0,2.5,17H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5H9.768a.5.5,0,0,0,.455-.7A8.032,8.032,0,0,1,9.5,17.5ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25A1.25,1.25,0,1,1,9.25,14.5,1.25,1.25,0,0,1,8,15.75Z', 'M1,20a.75.75,0,0,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5A1.25,1.25,0,1,1,4.25,3.75,1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.75,2.5Z', 'M17.427,9.509a.509.509,0,0,0,.49-.378A2.467,2.467,0,0,0,17.9,7.8,2.6,2.6,0,0,0,15.376,6H2.647A2.6,2.6,0,0,0,.013,8.239,2.5,2.5,0,0,0,2.5,11H12.705a.479.479,0,0,0,.271-.086A7.832,7.832,0,0,1,17.427,9.509ZM9.25,8.5A1.25,1.25,0,1,1,8,7.25,1.25,1.25,0,0,1,9.25,8.5ZM5.5,8.5A1.25,1.25,0,1,1,4.25,7.25,1.25,1.25,0,0,1,5.5,8.5Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm9-.75a.75.75,0,0,1,0,1.5H18.5a.25.25,0,0,0-.25.25V20a.75.75,0,0,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H15a.75.75,0,0,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V15a.75.75,0,0,1,1.5,0v1.5a.25.25,0,0,0,.25.25Z']],
  ServerRemove: ['server-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5v1A2.5,2.5,0,0,0,2.5,6ZM3.635,3A1.115,1.115,0,1,1,4.75,4.115,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.115,1.114,1.114,0,0,1,7.5,3Z', 'M17.5,9.5a7.957,7.957,0,0,1,3.777.949A.493.493,0,0,0,22,10.01c0-.135,0-.3,0-.508A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13h8.139a.49.49,0,0,0,.4-.206A7.992,7.992,0,0,1,17.5,9.5ZM9.729,10A1.115,1.115,0,1,1,8.615,8.885,1.114,1.114,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M0,17.5A2.5,2.5,0,0,0,2.5,20H9.242a.505.505,0,0,0,.481-.638,7.868,7.868,0,0,1,.3-4.687A.5.5,0,0,0,9.56,14H2.5A2.5,2.5,0,0,0,0,16.5ZM3.635,17A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm3.849-1.591a.75.75,0,0,1,1.06-1.061l1.414,1.414a.25.25,0,0,0,.354,0l1.414-1.414a.75.75,0,1,1,1.06,1.061l-1.414,1.414a.252.252,0,0,0,0,.354l1.414,1.414a.75.75,0,1,1-1.06,1.06l-1.414-1.414a.25.25,0,0,0-.354,0l-1.414,1.414a.75.75,0,1,1-1.06-1.06l1.414-1.414a.252.252,0,0,0,0-.354Z']],
  ServerSearch: ['server-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.5A2.5,2.5,0,0,0,2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5ZM3.635,3A1.115,1.115,0,1,1,4.75,4.115,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.115,1.114,1.114,0,0,1,7.5,3Z', 'M16.529,9.5a6.98,6.98,0,0,1,4.617,1.743.5.5,0,0,0,.806-.274A8.286,8.286,0,0,0,22,9.5,2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13h7.687a.491.491,0,0,0,.415-.234A7.024,7.024,0,0,1,16.529,9.5Zm-6.8.5A1.115,1.115,0,1,1,8.615,8.885,1.114,1.114,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M2.5,20H9.622a.494.494,0,0,0,.457-.689,6.937,6.937,0,0,1-.308-4.694A.5.5,0,0,0,9.285,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20Zm1.135-3A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17Z', 'M11,16.529a5.524,5.524,0,0,0,8.5,4.66.25.25,0,0,1,.311.034l2.484,2.484a1,1,0,0,0,1.414-1.414l-2.484-2.484a.251.251,0,0,1-.034-.312A5.527,5.527,0,1,0,11,16.529ZM16.529,13A3.529,3.529,0,1,1,13,16.529,3.533,3.533,0,0,1,16.529,13Z']],
  ServerShare: ['server-share', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.484a2.5,2.5,0,0,0,2.5,2.5h17a2.5,2.5,0,0,0,2.5-2.5v-1a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,2.484Zm3.635-.5A1.115,1.115,0,1,1,4.75,4.1,1.115,1.115,0,0,1,3.635,2.984Zm3.865,0A1.115,1.115,0,1,1,8.615,4.1,1.114,1.114,0,0,1,7.5,2.984Z', 'M21.25,9.515a4.21,4.21,0,0,1,.75.076,2.506,2.506,0,0,0-2.5-2.607H2.5A2.5,2.5,0,0,0,0,9.484v1a2.5,2.5,0,0,0,2.5,2.5H16.683a.5.5,0,0,0,.481-.365A4.25,4.25,0,0,1,21.25,9.515ZM9.729,9.984A1.115,1.115,0,1,1,8.615,8.869,1.114,1.114,0,0,1,9.729,9.984Zm-3.864,0A1.115,1.115,0,1,1,4.75,8.869,1.115,1.115,0,0,1,5.865,9.984Z', 'M2.5,13.984a2.5,2.5,0,0,0-2.5,2.5v1a2.5,2.5,0,0,0,2.5,2.5H9.163a.5.5,0,0,0,.4-.2.506.506,0,0,0,.086-.435A4.111,4.111,0,0,1,9.5,18.265a4.256,4.256,0,0,1,2.328-3.79.248.248,0,0,0-.12-.466Zm1.135,3A1.115,1.115,0,1,1,4.75,18.1,1.115,1.115,0,0,1,3.635,16.984Z', 'M24,13.765a2.746,2.746,0,1,0-5.437.539.25.25,0,0,1-.116.268l-2.665,1.6a.248.248,0,0,1-.288-.022,2.752,2.752,0,1,0,.311,3.925.252.252,0,0,1,.281-.067l2.272.909a.25.25,0,0,1,.156.246,2.758,2.758,0,1,0,.681-1.706.25.25,0,0,1-.281.068l-2.264-.906a.251.251,0,0,1-.156-.253,2.1,2.1,0,0,0-.057-.638.252.252,0,0,1,.116-.269l2.665-1.6a.25.25,0,0,1,.288.021,2.72,2.72,0,0,0,1.744.634A2.752,2.752,0,0,0,24,13.765Z']],
  ServerStar: ['server-star', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.484a2.5,2.5,0,0,0,2.5,2.5h17a2.5,2.5,0,0,0,2.5-2.5v-1a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,2.484Zm3.636-.5A1.115,1.115,0,1,1,4.751,4.1,1.114,1.114,0,0,1,3.637,2.984Zm3.864,0A1.115,1.115,0,1,1,8.616,4.1,1.114,1.114,0,0,1,7.5,2.984Z', 'M14.976,11.111a2.833,2.833,0,0,1,2.524-1.6c2.067,0,2.671,1.81,3.082,2.871a.248.248,0,0,0,.368.122A2.48,2.48,0,0,0,22,10.484v-1a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,9.484v1a2.5,2.5,0,0,0,2.5,2.5H13.838a.494.494,0,0,0,.457-.3ZM9.73,9.984A1.115,1.115,0,1,1,8.616,8.869,1.114,1.114,0,0,1,9.73,9.984Zm-3.864,0A1.115,1.115,0,1,1,4.751,8.869,1.115,1.115,0,0,1,5.866,9.984Z', 'M0,17.484a2.5,2.5,0,0,0,2.5,2.5h8.407a.5.5,0,0,0,.332-.872C10.21,18.224,9.01,16.893,9.7,15.2a2.706,2.706,0,0,1,.509-.8.25.25,0,0,0-.184-.419H2.5a2.5,2.5,0,0,0-2.5,2.5Zm3.636-.5A1.115,1.115,0,1,1,4.751,18.1,1.114,1.114,0,0,1,3.637,16.984Z', 'M14.989,14.863a.252.252,0,0,1-.229.151h-2.5a1.228,1.228,0,0,0-1.166.76,1.27,1.27,0,0,0,.319,1.4l2.194,1.955a.249.249,0,0,1,.063.286l-1.223,2.815a1.255,1.255,0,0,0,.315,1.451,1.287,1.287,0,0,0,.864.338,1.3,1.3,0,0,0,.642-.172l3.111-1.752a.251.251,0,0,1,.246,0l3.112,1.752a1.278,1.278,0,0,0,1.506-.166,1.256,1.256,0,0,0,.316-1.45l-1.224-2.816a.249.249,0,0,1,.063-.286l2.212-1.972a1.262,1.262,0,0,0,.3-1.378,1.232,1.232,0,0,0-1.169-.761h-2.5a.252.252,0,0,1-.23-.151l-1.344-3.117-.013-.027a1.293,1.293,0,0,0-2.317.027Z']],
  ServerWarning: ['server-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5v1A2.5,2.5,0,0,0,2.5,6ZM3.635,3A1.115,1.115,0,1,1,4.749,4.114,1.114,1.114,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.614,4.114,1.115,1.115,0,0,1,7.5,3Z', 'M14.892,11.574a2.952,2.952,0,0,1,3.339-1.486,3.061,3.061,0,0,1,1.934,1.59l.26.495a.5.5,0,0,0,.765.154A2.468,2.468,0,0,0,22,10.5v-1A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13H13.842a.5.5,0,0,0,.442-.268ZM9.729,10A1.115,1.115,0,1,1,8.614,8.885,1.115,1.115,0,0,1,9.729,10ZM5.864,10A1.115,1.115,0,1,1,4.749,8.885,1.115,1.115,0,0,1,5.864,10Z', 'M2.5,20h7.67a.5.5,0,0,0,.442-.268l2.624-5A.5.5,0,0,0,12.792,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20Zm1.136-3a1.115,1.115,0,1,1,1.114,1.115A1.114,1.114,0,0,1,3.635,17ZM7.5,17a1.115,1.115,0,1,1,1.115,1.115A1.115,1.115,0,0,1,7.5,17Z', 'M11.165,21.905a1.429,1.429,0,0,0,.048,1.408A1.453,1.453,0,0,0,12.446,24H22.558a1.455,1.455,0,0,0,1.232-.687,1.429,1.429,0,0,0,.048-1.408l-5.055-9.634a1.45,1.45,0,0,0-2.562,0ZM17.5,14.75a.75.75,0,0,1,.75.75v3a.75.75,0,0,1-1.5,0v-3A.75.75,0,0,1,17.5,14.75Zm1,6.5a1,1,0,1,1-1-1A1,1,0,0,1,18.5,21.25Z']],
  ServerWarning1: ['server-warning-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.137,20.633a.434.434,0,0,0-.227-.6.251.251,0,0,1-.158-.233V17.25A.25.25,0,0,1,10,17h1.739a.5.5,0,0,0,.442-.268l2.1-4A.5.5,0,0,0,13.84,12H2.649A2.6,2.6,0,0,0,.015,14.239,2.5,2.5,0,0,0,2.5,17H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,1,0,0,1.5H9.4a.5.5,0,0,0,.455-.292C9.935,21.03,10.031,20.839,10.137,20.633ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,8,15.75Z', 'M1,20a.75.75,0,1,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.752,2.5Z', 'M17.628,9.8A2.447,2.447,0,0,0,18,8.546,2.651,2.651,0,0,0,15.322,6H2.649A2.6,2.6,0,0,0,.015,8.239,2.5,2.5,0,0,0,2.5,11H15.1a.493.493,0,0,0,.347-.15,2.923,2.923,0,0,1,1.8-.837A.5.5,0,0,0,17.628,9.8ZM3,8.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,8.5Zm3.75,0A1.25,1.25,0,1,1,8,9.75,1.249,1.249,0,0,1,6.752,8.5Z', 'M18.78,12.271a1.45,1.45,0,0,0-2.562,0l-5.055,9.634a1.429,1.429,0,0,0,.048,1.408A1.456,1.456,0,0,0,12.444,24H22.555a1.456,1.456,0,0,0,1.233-.687,1.429,1.429,0,0,0,.048-1.408ZM16.5,21.25a1,1,0,1,1,1,1A1,1,0,0,1,16.5,21.25Zm1.75-2.75a.75.75,0,0,1-1.5,0v-3a.75.75,0,1,1,1.5,0Z']],
  ServerDownload1: ['server-download-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.375,17.375a7.928,7.928,0,0,1,1.377-4.47.5.5,0,0,0-.408-.78H2.772A2.6,2.6,0,0,0,.138,14.364a2.5,2.5,0,0,0,2.487,2.761h5.5a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25h-3a.75.75,0,0,0,0,1.5H9.762a.5.5,0,0,0,.446-.714A7.912,7.912,0,0,1,9.375,17.375Zm-6.25-2.75a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3.125,14.625Zm5,1.25a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,8.125,15.875Z', 'M1.125,21.625h1a.75.75,0,0,0,0-1.5h-1a.75.75,0,0,0,0,1.5Z', 'M2.625,5.125h13a2.5,2.5,0,0,0,0-5h-13a2.5,2.5,0,0,0,0,5Zm.5-2.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3.125,2.625Zm3.75,0a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,6.875,2.625Z', 'M17.587,9.378a.5.5,0,0,0,.511-.445,2.49,2.49,0,0,0-2.473-2.808H2.772A2.6,2.6,0,0,0,.138,8.364a2.5,2.5,0,0,0,2.487,2.761H12.23a.494.494,0,0,0,.3-.1A7.956,7.956,0,0,1,17.587,9.378ZM9.375,8.625a1.25,1.25,0,1,1-1.25-1.25A1.25,1.25,0,0,1,9.375,8.625Zm-3.75,0a1.25,1.25,0,1,1-1.25-1.25A1.25,1.25,0,0,1,5.625,8.625Z', 'M10.875,17.375a6.5,6.5,0,1,0,6.5-6.5A6.508,6.508,0,0,0,10.875,17.375Zm7.5-3v2.75a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.391.812l-2,2.5a.5.5,0,0,1-.782,0l-2-2.5a.5.5,0,0,1,.391-.812h.75a.25.25,0,0,0,.25-.25v-2.75a1,1,0,0,1,2,0Z']],
  ServerLock: ['server-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.5A2.5,2.5,0,0,0,2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5ZM3.635,3A1.115,1.115,0,1,1,4.75,4.115,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.115,1.114,1.114,0,0,1,7.5,3Z', 'M19,9a4.9,4.9,0,0,1,2.567.729A.279.279,0,0,0,22,9.5h0A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13H13.713a.5.5,0,0,0,.48-.378A5,5,0,0,1,19,9ZM9.729,10A1.115,1.115,0,1,1,8.615,8.885,1.114,1.114,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M2.5,20H12a.5.5,0,0,0,.5-.5V16a1.813,1.813,0,0,1,.75-1.551A.253.253,0,0,0,13.09,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20Zm1.135-3A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17ZM7.5,17a1.115,1.115,0,1,1,1.115,1.114A1.114,1.114,0,0,1,7.5,17Z', 'M15.5,15.268a.25.25,0,0,1-.214.247A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17a1.5,1.5,0,0,0-1.286-1.485.25.25,0,0,1-.214-.247V14.25a3.5,3.5,0,0,0-7,0ZM20,20.25a1,1,0,1,1-1-1A1,1,0,0,1,20,20.25Zm-1-7.5a1.5,1.5,0,0,1,1.5,1.5v1a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25v-1A1.5,1.5,0,0,1,19,12.75Z']],
  ServerSettings: ['server-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.509,6.015h17a2.5,2.5,0,0,0,2.5-2.5v-1a2.5,2.5,0,0,0-2.5-2.5h-17a2.5,2.5,0,0,0-2.5,2.5v1A2.5,2.5,0,0,0,2.509,6.015Zm1.135-3A1.115,1.115,0,1,1,4.759,4.13,1.113,1.113,0,0,1,3.644,3.015Zm3.865,0A1.115,1.115,0,1,1,8.623,4.13,1.113,1.113,0,0,1,7.509,3.015Z', 'M17.759,8.532a8.4,8.4,0,0,1,3.412.723.5.5,0,0,0,.675-.622,2.538,2.538,0,0,0-2.337-1.618h-17a2.5,2.5,0,0,0-2.5,2.5v1a2.5,2.5,0,0,0,2.5,2.5H9.987a.49.49,0,0,0,.423-.248A8.5,8.5,0,0,1,17.759,8.532ZM9.738,10.015A1.115,1.115,0,1,1,8.623,8.9,1.115,1.115,0,0,1,9.738,10.015Zm-3.865,0A1.115,1.115,0,1,1,4.759,8.9,1.115,1.115,0,0,1,5.873,10.015Z', 'M2.509,20.015H9.117a.5.5,0,0,0,.484-.624,8.328,8.328,0,0,1,0-4.742.5.5,0,0,0-.48-.634H2.509a2.5,2.5,0,0,0-2.5,2.5v1A2.5,2.5,0,0,0,2.509,20.015Zm1.135-3a1.115,1.115,0,1,1,1.115,1.114A1.114,1.114,0,0,1,3.644,17.015Z', 'M16.239 17.015 A1.500 1.500 0 1 0 19.239 17.015 A1.500 1.500 0 1 0 16.239 17.015 Z', 'M13.671,12.684a1.783,1.783,0,0,0-1.7,2.953l.987,1.066a.461.461,0,0,1,0,.625l-.987,1.065a1.783,1.783,0,0,0,1.7,2.953l1.412-.327a.456.456,0,0,1,.533.311l.423,1.391a1.776,1.776,0,0,0,3.4,0l.423-1.391a.449.449,0,0,1,.534-.311l1.411.327a1.783,1.783,0,0,0,1.7-2.953l-.988-1.065a.463.463,0,0,1,0-.625l.988-1.066a1.783,1.783,0,0,0-1.7-2.953l-1.412.327a.454.454,0,0,1-.532-.31l-.424-1.392a1.776,1.776,0,0,0-3.4,0L15.616,12.7a.456.456,0,0,1-.534.31Zm7.068,4.331a3,3,0,1,1-3-3A3,3,0,0,1,20.739,17.015Z']],
  ServerMonitorExchange: ['server-monitor-exchange', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.2,13.528a2,2,0,0,0-2-2h-8a2,2,0,0,0-2,2v5.693a2.022,2.022,0,0,0,2,1.807H4.95a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H3.7a1,1,0,1,0,0,2h5a1,1,0,0,0,0-2H7.45a.25.25,0,0,1-.25-.25v-.5a.25.25,0,0,1,.25-.25H10.2a2.022,2.022,0,0,0,2-1.807Zm-2.5,0a.5.5,0,0,1,.5.5v3.5a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5v-3.5a.5.5,0,0,1,.5-.5Z', 'M10.076,5.169a.506.506,0,0,0,.524-.047l2-1.5a.5.5,0,0,0,0-.8l-2-1.5a.5.5,0,0,0-.8.4v.25a.25.25,0,0,1-.25.25H7.8a3,3,0,0,0-3,3v1.5a.25.25,0,0,1-.25.25H4.3a.5.5,0,0,0-.4.8l1.5,2a.5.5,0,0,0,.8,0l1.5-2a.5.5,0,0,0-.4-.8H7.05a.25.25,0,0,1-.25-.25v-1.5a1,1,0,0,1,1-1H9.55a.25.25,0,0,1,.25.25v.25A.5.5,0,0,0,10.076,5.169Z', 'M21.8-.029h-6a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4Zm-6,2a1,1,0,1,1,1,1A1,1,0,0,1,15.8,1.971Z', 'M21.8,4.971h-6a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4Zm-6,2a1,1,0,1,1,1,1A1,1,0,0,1,15.8,6.971Z', 'M21.8,9.971h-6a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4Zm-6,2a1,1,0,1,1,1,1A1,1,0,0,1,15.8,11.971Z']],
  ServerRefresh: ['server-refresh', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.511,6.125h17a2.5,2.5,0,0,0,2.5-2.5v-1a2.5,2.5,0,0,0-2.5-2.5h-17a2.5,2.5,0,0,0-2.5,2.5v1A2.5,2.5,0,0,0,2.511,6.125Zm1.135-3A1.115,1.115,0,1,1,4.761,4.239,1.115,1.115,0,0,1,3.646,3.125Zm3.865,0A1.115,1.115,0,1,1,8.625,4.239,1.114,1.114,0,0,1,7.511,3.125Z', 'M17.011,9.625a7.7,7.7,0,0,1,4.238,1.267.493.493,0,0,0,.763-.411c0-.2,0-.47,0-.85a2.509,2.509,0,0,0-2.5-2.506h-17a2.5,2.5,0,0,0-2.5,2.5v1a2.5,2.5,0,0,0,2.5,2.5h7.77a.492.492,0,0,0,.4-.212A7.741,7.741,0,0,1,17.011,9.625Zm-7.271.5A1.115,1.115,0,1,1,8.625,9.01,1.115,1.115,0,0,1,9.74,10.124Zm-3.865,0A1.115,1.115,0,1,1,4.761,9.01,1.115,1.115,0,0,1,5.875,10.124Z', 'M2.511,20.125h6.57a.5.5,0,0,0,.474-.658,7.614,7.614,0,0,1,.162-4.692.5.5,0,0,0-.476-.65H2.511a2.5,2.5,0,0,0-2.5,2.5v1A2.5,2.5,0,0,0,2.511,20.125Zm1.135-3a1.115,1.115,0,1,1,1.115,1.115A1.115,1.115,0,0,1,3.646,17.124Z', 'M21.838,12.84a.25.25,0,0,1-.348.006A6.373,6.373,0,0,0,10.761,17.5a6.374,6.374,0,0,0,11.357,3.976,1,1,0,0,0-1.562-1.248,4.374,4.374,0,1,1-.5-5.982.251.251,0,0,1,.009.363L18.679,16a.5.5,0,0,0,.353.853h4.457a.5.5,0,0,0,.5-.5V11.9a.5.5,0,0,0-.853-.353l-.508.508Z']],
  ServerStar1: ['server-star-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.953,20a.249.249,0,0,1-.25-.25V17.1a2.705,2.705,0,0,1,.05-1.91,2.741,2.741,0,0,1,2.553-1.69h1.352a.5.5,0,0,0,.459-.3l.215-.5a.5.5,0,0,0-.459-.7H2.453a2.5,2.5,0,0,0,0,5h5.5a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25h-3a.75.75,0,1,0,0,1.5h5.886a.5.5,0,0,0,.459-.3l.217-.5a.5.5,0,0,0-.458-.7Zm-7-5.5A1.25,1.25,0,1,1,4.2,15.75,1.249,1.249,0,0,1,2.953,14.5Zm5,1.25A1.25,1.25,0,1,1,9.2,14.5,1.25,1.25,0,0,1,7.953,15.75Z', 'M1.953,20h-1a.75.75,0,1,0,0,1.5h1a.75.75,0,0,0,0-1.5Z', 'M2.453,5h13a2.5,2.5,0,0,0,0-5h-13a2.5,2.5,0,0,0,0,5Zm.5-2.5A1.25,1.25,0,1,1,4.2,3.75,1.249,1.249,0,0,1,2.953,2.5Zm3.75,0a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,6.7,2.5Z', 'M17.4,9.516a.5.5,0,0,0,.461-.366,2.406,2.406,0,0,0,.09-.65,2.5,2.5,0,0,0-2.5-2.5h-13a2.5,2.5,0,0,0,0,5H14.8a.5.5,0,0,0,.421-.23A2.67,2.67,0,0,1,17.4,9.516ZM2.953,8.5A1.25,1.25,0,1,1,4.2,9.75,1.249,1.249,0,0,1,2.953,8.5Zm5,1.25A1.25,1.25,0,1,1,9.2,8.5,1.25,1.25,0,0,1,7.953,9.75Z', 'M22.788,15h-2.5a.248.248,0,0,1-.229-.151l-1.344-3.116L18.7,11.7a1.293,1.293,0,0,0-2.317.028l-1.346,3.116a.25.25,0,0,1-.23.151h-2.5a1.23,1.23,0,0,0-1.166.76,1.272,1.272,0,0,0,.32,1.4l2.194,1.954a.252.252,0,0,1,.063.287L12.494,22.21a1.253,1.253,0,0,0,.314,1.451,1.278,1.278,0,0,0,1.506.166l3.112-1.752a.249.249,0,0,1,.245,0l3.113,1.752a1.273,1.273,0,0,0,1.506-.166,1.254,1.254,0,0,0,.315-1.45L21.382,19.4a.25.25,0,0,1,.062-.287l2.213-1.971a1.264,1.264,0,0,0,.3-1.378A1.234,1.234,0,0,0,22.788,15Z']],
  ServerUpload: ['server-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.75,6h17a2.5,2.5,0,0,0,2.5-2.5v-1A2.5,2.5,0,0,0,19.75,0h-17A2.5,2.5,0,0,0,.25,2.5v1A2.5,2.5,0,0,0,2.75,6ZM3.885,3A1.115,1.115,0,1,1,5,4.115,1.115,1.115,0,0,1,3.885,3ZM7.75,3A1.115,1.115,0,1,1,8.865,4.115,1.114,1.114,0,0,1,7.75,3Z', 'M17.25,9.5A7.919,7.919,0,0,1,21.5,10.731a.493.493,0,0,0,.756-.416c0-.2,0-.45,0-.81A2.509,2.509,0,0,0,19.75,7h-17A2.5,2.5,0,0,0,.25,9.5v1A2.5,2.5,0,0,0,2.75,13h7.639a.49.49,0,0,0,.4-.206A7.992,7.992,0,0,1,17.25,9.5ZM9.979,10A1.115,1.115,0,1,1,8.865,8.885,1.114,1.114,0,0,1,9.979,10ZM6.115,10A1.115,1.115,0,1,1,5,8.885,1.115,1.115,0,0,1,6.115,10Z', 'M2.75,20H8.992a.505.505,0,0,0,.481-.638,7.868,7.868,0,0,1,.3-4.687A.5.5,0,0,0,9.31,14H2.75a2.5,2.5,0,0,0-2.5,2.5v1A2.5,2.5,0,0,0,2.75,20Zm1.135-3A1.115,1.115,0,1,1,5,18.114,1.115,1.115,0,0,1,3.885,17Z', 'M10.75,17.5a6.5,6.5,0,1,0,6.5-6.5A6.508,6.508,0,0,0,10.75,17.5Zm6.5,4a1,1,0,0,1-1-1V17.75A.25.25,0,0,0,16,17.5h-.75a.5.5,0,0,1-.391-.813l2-2.5a.52.52,0,0,1,.782,0l2,2.5a.5.5,0,0,1-.391.813H18.5a.25.25,0,0,0-.25.25V20.5A1,1,0,0,1,17.25,21.5Z']],
  ServerSettings1: ['server-settings-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.134,17.047a8.419,8.419,0,0,1,1.18-4.3A.494.494,0,0,0,9.886,12h-7.1A2.6,2.6,0,0,0,.147,14.239,2.5,2.5,0,0,0,2.634,17h5.5a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25h-3a.75.75,0,0,0,0,1.5h4.43a.5.5,0,0,0,.448-.711A8.412,8.412,0,0,1,9.134,17.047Zm-6-2.547a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3.134,14.5Zm5,1.25a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,8.134,15.75Z', 'M1.134,20a.75.75,0,0,0,0,1.5h1a.75.75,0,1,0,0-1.5Z', 'M2.634,5h13a2.5,2.5,0,0,0,0-5h-13a2.5,2.5,0,0,0,0,5Zm.5-2.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3.134,2.5Zm3.75,0a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,6.884,2.5Z', 'M17.568,8.557a.5.5,0,0,0,.506-.584A2.5,2.5,0,0,0,15.634,6H2.781A2.6,2.6,0,0,0,.147,8.239,2.5,2.5,0,0,0,2.634,11H11.67A8.4,8.4,0,0,1,17.568,8.557ZM9.384,8.5a1.25,1.25,0,1,1-1.25-1.25A1.25,1.25,0,0,1,9.384,8.5Zm-3.75,0a1.25,1.25,0,1,1-1.25-1.25A1.25,1.25,0,0,1,5.634,8.5Z', 'M16.114 17.031 A1.500 1.500 0 1 0 19.114 17.031 A1.500 1.500 0 1 0 16.114 17.031 Z', 'M15.491,12.717a.455.455,0,0,1-.534.31L13.546,12.7a1.783,1.783,0,0,0-1.7,2.953l.987,1.065a.461.461,0,0,1,0,.625l-.987,1.066a1.783,1.783,0,0,0,1.7,2.953l1.412-.327a.455.455,0,0,1,.533.31l.423,1.392a1.776,1.776,0,0,0,3.4,0l.423-1.392a.448.448,0,0,1,.534-.31l1.411.327a1.783,1.783,0,0,0,1.7-2.953L22.4,17.343a.463.463,0,0,1,0-.625l.988-1.065a1.783,1.783,0,0,0-1.7-2.953l-1.412.327a.45.45,0,0,1-.532-.31l-.424-1.392a1.776,1.776,0,0,0-3.4,0Zm2.123,7.314a3,3,0,1,1,3-3A3,3,0,0,1,17.614,20.031Z']],
  ServerAdd: ['server-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.5A2.5,2.5,0,0,0,2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5ZM3.635,3A1.115,1.115,0,1,1,4.75,4.115,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.115,1.114,1.114,0,0,1,7.5,3Z', 'M17.5,9.5a7.957,7.957,0,0,1,3.777.949A.493.493,0,0,0,22,10.01c0-.136,0-.3,0-.508A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13h8.139a.491.491,0,0,0,.4-.206A7.992,7.992,0,0,1,17.5,9.5ZM9.729,10A1.115,1.115,0,1,1,8.615,8.885,1.114,1.114,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M9.56,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20H9.242a.5.5,0,0,0,.481-.638,7.866,7.866,0,0,1,.3-4.687A.5.5,0,0,0,9.56,14ZM3.635,17A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm5.75,1a.25.25,0,0,0-.25-.25H15a.75.75,0,0,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V15a.75.75,0,0,1,1.5,0v1.5a.25.25,0,0,0,.25.25H20a.75.75,0,0,1,0,1.5H18.5a.25.25,0,0,0-.25.25V20a.75.75,0,0,1-1.5,0Z']],
  ServerClock: ['server-clock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.5A2.5,2.5,0,0,0,2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5ZM3.635,3A1.115,1.115,0,1,1,4.75,4.114,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.114,1.114,1.114,0,0,1,7.5,3Z', 'M17.25,9a8.169,8.169,0,0,1,4.006,1.046A.5.5,0,0,0,22,9.611V9.5A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13H9.924a.488.488,0,0,0,.411-.228A8.24,8.24,0,0,1,17.25,9ZM9.729,10A1.115,1.115,0,1,1,8.615,8.885,1.115,1.115,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M0,17.5A2.5,2.5,0,0,0,2.5,20H8.8a.5.5,0,0,0,.477-.648,8.152,8.152,0,0,1,.146-4.711A.5.5,0,0,0,8.946,14H2.5A2.5,2.5,0,0,0,0,16.5ZM3.635,17A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17Z', 'M10.5,17.25a6.75,6.75,0,1,0,6.75-6.75A6.758,6.758,0,0,0,10.5,17.25ZM17.25,22A4.75,4.75,0,1,1,22,17.25,4.756,4.756,0,0,1,17.25,22Z', 'M16.25,17.25a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2H18.5a.25.25,0,0,1-.25-.25V14.75a1,1,0,0,0-2,0Z']],
  ServerQuestion: ['server-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.5A2.5,2.5,0,0,0,2.5,6h17A2.5,2.5,0,0,0,22,3.5v-1A2.5,2.5,0,0,0,19.5,0H2.5A2.5,2.5,0,0,0,0,2.5ZM3.635,3A1.115,1.115,0,1,1,4.75,4.115,1.115,1.115,0,0,1,3.635,3ZM7.5,3A1.115,1.115,0,1,1,8.615,4.115,1.114,1.114,0,0,1,7.5,3Z', 'M17.5,9.5a7.957,7.957,0,0,1,3.777.949A.493.493,0,0,0,22,10.01c0-.136,0-.3,0-.508A2.5,2.5,0,0,0,19.5,7H2.5A2.5,2.5,0,0,0,0,9.5v1A2.5,2.5,0,0,0,2.5,13h8.139a.491.491,0,0,0,.4-.206A7.992,7.992,0,0,1,17.5,9.5ZM9.729,10A1.115,1.115,0,1,1,8.615,8.885,1.114,1.114,0,0,1,9.729,10ZM5.865,10A1.115,1.115,0,1,1,4.75,8.885,1.115,1.115,0,0,1,5.865,10Z', 'M9.56,14H2.5A2.5,2.5,0,0,0,0,16.5v1A2.5,2.5,0,0,0,2.5,20H9.242a.5.5,0,0,0,.481-.638,7.866,7.866,0,0,1,.3-4.687A.5.5,0,0,0,9.56,14ZM3.635,17A1.115,1.115,0,1,1,4.75,18.114,1.115,1.115,0,0,1,3.635,17Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm5.75,1.25V18.2a1.258,1.258,0,0,1,.986-1.222,1.125,1.125,0,1,0-1.361-1.1.75.75,0,0,1-1.5,0,2.625,2.625,0,1,1,3.538,2.461.25.25,0,0,0-.163.234v.18a.75.75,0,0,1-1.5,0Zm.75,1.75a1,1,0,1,1-1,1A1,1,0,0,1,17.5,20.5Z']],
  ServerRefresh1: ['server-refresh-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.272,17.625a7.691,7.691,0,0,1,1.785-4.931.5.5,0,0,0-.385-.819H2.5a2.5,2.5,0,0,0,0,5H8a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25H5a.75.75,0,0,0,0,1.5H9.441a.5.5,0,0,0,.46-.7A7.691,7.691,0,0,1,9.272,17.625ZM3,14.375a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.375Zm5,1.25a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,8,15.625Z', 'M1,19.875a.75.75,0,0,0,0,1.5H2a.75.75,0,0,0,0-1.5Z', 'M2.5,4.875h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5Zm.5-2.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,2.375Zm3.75,0A1.25,1.25,0,1,1,8,3.625,1.249,1.249,0,0,1,6.75,2.375Z', 'M17.2,9.882a.5.5,0,0,0,.448-.243A2.443,2.443,0,0,0,18,8.375a2.5,2.5,0,0,0-2.5-2.5H2.5a2.5,2.5,0,0,0,0,5H13.1a.493.493,0,0,0,.238-.061A7.584,7.584,0,0,1,17.2,9.882ZM3,8.375a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,8.375Zm5,1.25a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,8,9.625Z', 'M21.849,13.09a.249.249,0,0,1-.348.005,6.375,6.375,0,1,0,.628,8.631,1,1,0,1,0-1.562-1.248,4.375,4.375,0,1,1-.5-5.982.252.252,0,0,1,.083.179.257.257,0,0,1-.073.184L18.69,16.25a.5.5,0,0,0,.353.853H23.5a.5.5,0,0,0,.5-.5V12.146a.5.5,0,0,0-.854-.353l-.508.508Z']],
  ServerSubtract1: ['server-subtract-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a7.939,7.939,0,0,1,1.543-4.707.5.5,0,0,0-.4-.793h-8A2.6,2.6,0,0,0,.013,14.239,2.5,2.5,0,0,0,2.5,17H8a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8,20H5a.75.75,0,0,0,0,1.5H9.768a.5.5,0,0,0,.455-.7A8.032,8.032,0,0,1,9.5,17.5ZM3,14.5a1.25,1.25,0,1,1,1.25,1.25A1.249,1.249,0,0,1,3,14.5Zm5,1.25A1.25,1.25,0,1,1,9.25,14.5,1.25,1.25,0,0,1,8,15.75Z', 'M1,20a.75.75,0,0,0,0,1.5H2A.75.75,0,0,0,2,20Z', 'M2.5,5h13a2.5,2.5,0,0,0,0-5H2.5a2.5,2.5,0,0,0,0,5ZM3,2.5A1.25,1.25,0,1,1,4.25,3.75,1.249,1.249,0,0,1,3,2.5Zm3.75,0A1.25,1.25,0,1,1,8,3.75,1.249,1.249,0,0,1,6.75,2.5Z', 'M17.427,9.509a.509.509,0,0,0,.49-.378A2.467,2.467,0,0,0,17.9,7.8,2.6,2.6,0,0,0,15.376,6H2.647A2.6,2.6,0,0,0,.013,8.239,2.5,2.5,0,0,0,2.5,11H12.705a.479.479,0,0,0,.271-.086A7.832,7.832,0,0,1,17.427,9.509ZM9.25,8.5A1.25,1.25,0,1,1,8,7.25,1.25,1.25,0,0,1,9.25,8.5ZM5.5,8.5A1.25,1.25,0,1,1,4.25,7.25,1.25,1.25,0,0,1,5.5,8.5Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm9,.75H15a.75.75,0,0,1,0-1.5h5a.75.75,0,0,1,0,1.5Z']],
  ServerHeart: ['server-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,3.484a2.5,2.5,0,0,0,2.5,2.5h17a2.5,2.5,0,0,0,2.5-2.5v-1a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,2.484Zm3.635-.5A1.115,1.115,0,1,1,4.75,4.1,1.114,1.114,0,0,1,3.635,2.984Zm3.865,0A1.115,1.115,0,1,1,8.614,4.1,1.114,1.114,0,0,1,7.5,2.984Z', 'M13.72,11.08a5.031,5.031,0,0,1,3.639.811.25.25,0,0,0,.282,0,5.031,5.031,0,0,1,3.637-.811l.123.021a.5.5,0,0,0,.592-.45c0-.055.007-.111.007-.167v-1a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,9.484v1a2.5,2.5,0,0,0,2.5,2.5h7.818a.491.491,0,0,0,.374-.179A5.023,5.023,0,0,1,13.72,11.08Zm-3.991-1.1A1.115,1.115,0,1,1,8.614,8.869,1.115,1.115,0,0,1,9.729,9.984Zm-3.865,0A1.115,1.115,0,1,1,4.75,8.869,1.114,1.114,0,0,1,5.864,9.984Z', 'M9.234,13.984H2.5a2.5,2.5,0,0,0-2.5,2.5v1a2.5,2.5,0,0,0,2.5,2.5h7.767a.5.5,0,0,0,.389-.8,4.823,4.823,0,0,1-.947-4.556A.494.494,0,0,0,9.234,13.984Zm-5.6,3A1.115,1.115,0,1,1,4.75,18.1,1.114,1.114,0,0,1,3.635,16.984Z', 'M21.038,12.561a3.475,3.475,0,0,0-3.056.988l-.306.3a.249.249,0,0,1-.353,0l-.3-.3a3.524,3.524,0,0,0-5.646.916,3.517,3.517,0,0,0,.653,4.061l5.114,5.335a.5.5,0,0,0,.721,0l5.107-5.327a3.522,3.522,0,0,0,.661-4.069A3.487,3.487,0,0,0,21.038,12.561Z']],
  ServerPhoneExchange: ['server-phone-exchange', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.026,3.947A.508.508,0,0,0,9.25,4a.5.5,0,0,0,.3-.1l2-1.5a.5.5,0,0,0,0-.8L9.55.1A.505.505,0,0,0,9.026.052.5.5,0,0,0,8.75.5V.75A.25.25,0,0,1,8.5,1H6.75a3,3,0,0,0-3,3V5.5a.25.25,0,0,1-.25.25H3.25a.5.5,0,0,0-.4.8l1.5,2a.5.5,0,0,0,.8,0l1.5-2a.5.5,0,0,0-.4-.8H6a.25.25,0,0,1-.25-.25V4a1,1,0,0,1,1-1H8.5a.25.25,0,0,1,.25.25V3.5A.5.5,0,0,0,9.026,3.947Z', 'M24,2a2,2,0,0,0-2-2H16a2,2,0,0,0,0,4h6A2,2,0,0,0,24,2ZM16,2a1,1,0,1,1,1,1A1,1,0,0,1,16,2Z', 'M22,5H16a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4ZM16,7a1,1,0,1,1,1,1A1,1,0,0,1,16,7Z', 'M22,10H16a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4Zm-6,2a1,1,0,1,1,1,1A1,1,0,0,1,16,12Z', 'M1.75,24h6A1.752,1.752,0,0,0,9.5,22.25v-11A1.752,1.752,0,0,0,7.75,9.5h-6A1.752,1.752,0,0,0,0,11.25v11A1.752,1.752,0,0,0,1.75,24ZM2,11.75a.25.25,0,0,1,.25-.25h5a.25.25,0,0,1,.25.25v8.5a.25.25,0,0,1-.25.25h-5A.25.25,0,0,1,2,20.25Z']],
  ServerServerExchange: ['server-server-exchange', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.276,3.947A.508.508,0,0,0,9.5,4a.5.5,0,0,0,.3-.1l2-1.5a.5.5,0,0,0,0-.8L9.8.1A.505.505,0,0,0,9.276.052.5.5,0,0,0,9,.5V.75A.25.25,0,0,1,8.75,1H7A3,3,0,0,0,4,4V5.5a.25.25,0,0,1-.25.25H3.5a.5.5,0,0,0-.4.8l1.5,2a.5.5,0,0,0,.8,0l1.5-2a.5.5,0,0,0-.4-.8H6.25A.25.25,0,0,1,6,5.5V4A1,1,0,0,1,7,3H8.75A.25.25,0,0,1,9,3.25V3.5A.5.5,0,0,0,9.276,3.947Z', 'M2,14H8a2,2,0,0,0,0-4H2a2,2,0,0,0,0,4Zm2-2a1,1,0,1,1-1-1A1,1,0,0,1,4,12Z', 'M2,19H8a2,2,0,0,0,0-4H2a2,2,0,0,0,0,4Zm2-2a1,1,0,1,1-1-1A1,1,0,0,1,4,17Z', 'M2,24H8a2,2,0,0,0,0-4H2a2,2,0,0,0,0,4Zm2-2a1,1,0,1,1-1-1A1,1,0,0,1,4,22Z', 'M22,0H16a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4ZM16,2a1,1,0,1,1,1,1A1,1,0,0,1,16,2Z', 'M22,5H16a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4ZM16,7a1,1,0,1,1,1,1A1,1,0,0,1,16,7Z', 'M22,10H16a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4Zm-6,2a1,1,0,1,1,1,1A1,1,0,0,1,16,12Z']]
};
exports["default"] = _default;